<script>
	import model from "../stores/modelStore";
	import { projectSettings } from "../config";

	import ClassActionPhoneNumber from "../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../components/ClassActionEmailAddress.svelte";

	import PageSection from "../components/PageSection.svelte";
</script>

<PageSection>
	<div class="row justify-content-md-center">
		<div class="col-8">
			<h1>There is a Problem</h1>

			<p>
				Thank you for trying to complete your registration form for the {@html projectSettings.classActionName} Class
				Action. Unfortunately there has been a problem.
			</p>
			<p>
				Please contact Shine Lawyers on <ClassActionPhoneNumber></ClassActionPhoneNumber>, or at
				<ClassActionEmailAddress></ClassActionEmailAddress>, and quote the registration number below and we can
				help you out.
			</p>
			<p>
				Your registration number is: {$model.registrationNumber}
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}
</style>
